import { ElementState, Preview } from "@creatomate/preview";

import { ElementSource, Story } from "chq";

import { getImageFromStory, getSubdomain } from "app/utils";
import imagesSizes from "constants/imagesSizes";

const cacheAssetIfNeeded = async (
  preview: Preview,
  story: Story | undefined
): Promise<{ sourceUrl: string | undefined; name: string | undefined }> => {
  let sourceUrl;
  let name;
  if (story?.media instanceof File) {
    sourceUrl = `https://${getSubdomain()}.culturehq.com/${Date.now()}`;
    await preview.cacheAsset(sourceUrl, story?.media);
    name = `media-${story?.media?.name}`;
  } else if (story?.media?.urls) {
    sourceUrl = story?.media?.urls?.raw;
    name = `media-${story?.media?.alt_description}`;
  } else if (story?.media?.mediaJson && Object.keys(story.media.mediaJson).length > 0) {
    const mediaElement = story.media.mediaJson.elements.find((element: ElementSource) => element.name?.startsWith("media-"));
    sourceUrl = mediaElement.source;
    name = mediaElement.name;
  } else {
    sourceUrl = getImageFromStory(imagesSizes.FULL, story);
    name = `media-${story?.creator?.name}'s image`;
  }

  return { sourceUrl, name };
};

export default cacheAssetIfNeeded;
